import axios from "axios"

//const
const REPRE_LICENSE_LOCATION_GET = "editUserCertify/REPRE_LICENSE_LOCATION_GET"
const REPRE_LICENSE_TYPE_GET = "editUserCertify/REPRE_LICENSE_TYPE_GET"

//reducer
export const createUserCertify = (state = {
  licenseHomeLocations:[],
  licenseTypes: [],

},action) => {
  switch (action.type) {
    case REPRE_LICENSE_TYPE_GET:
      console.log("Type: ", action.data._embedded.repreLicenseTypes)
      return {
        ...state,
        licenseTypes:action.data._embedded.repreLicenseTypes

      };
    case REPRE_LICENSE_LOCATION_GET:
      console.log("REPRELICENSELOCATION: ", action.data._embedded.repreLicenseLocations)
      return {
        ...state,
        licenseHomeLocations:action.data._embedded.repreLicenseLocations

      };
    default:
      return state
  }
};

export const getRepreLicenseType = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/repreLicenseTypes`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("repreLicenseTypes",response.data);
        dispatch(getRepreLicenseTypeDone(response.data))
      }
    })
}

export const getRepreLicenseLocation = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/repreLicenseLocations`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("repreLicenseLocation",response.data);
        dispatch(getRepreLicenseLocationDone(response.data))
      }
    })
}

export const getRepreLicenseLocationDone = (data) => {
  return {
    type: REPRE_LICENSE_LOCATION_GET,
    data: data
  }
};

export const getRepreLicenseTypeDone = (data) => {
  return {
    type: REPRE_LICENSE_TYPE_GET,
    data: data
  }
};
